import React, { CSSProperties, ChangeEvent, useState, useCallback } from 'react';
import { IStyle } from 'Styles';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';

interface Props {
  inputStyle?: CSSProperties;
  containerStyle?: CSSProperties;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string | number;
  placeholder?: string;
  name?: string;
  icon?: React.ReactNode;
  inputType?: React.HTMLInputTypeAttribute;
  handleOnIconClick?: () => void;
  autoComplete?: string;
  iconPosition?: 'left' | 'right';
}

const IconInput = (props: Props) => {
  const {
    value,
    placeholder,
    onChange,
    inputStyle,
    containerStyle = '',
    name,
    icon,
    inputType = 'text',
    handleOnIconClick = null,
    autoComplete = 'on',
    iconPosition = 'right',
  } = props;

  const [_inputType, _setInputType] = useState(inputType);
  /**
   * This is to handle hide and show password action in password related fields.
   */
  const handlePasswordToggle = useCallback(() => {
    _setInputType((prv) => (prv === 'password' ? 'text' : 'password'));
  }, []);

  return (
    <div id='input-with-icon-input-wrapper' style={{ ...styles.wrapper, ...containerStyle }}>
      <div
        id='input-with-icon-input-password-toogle'
        className={`flex gap-1 ${
          iconPosition === 'left' ? 'left-[2px] flex-row-reverse' : 'right-[2px] flex-row'
        }`}
        style={styles.icon}
        onClick={inputType === 'password' ? handlePasswordToggle : handleOnIconClick}
      >
        <text id='input-with-icon-input-vertical-bar' style={styles.verticalBar}>|</text>
        {icon || (
          <RMSvgIcon
            id='input-with-icon-input-rm-svg-icon'
            height={18}
            width={18}
            fill="#F7A246"
            name={`${_inputType === 'password' ? 'EyeViewClose' : 'EyeView'}`}
          />
        )}
      </div>
      <input
       id='input-with-icon-input-on-change'
        name={name}
        type={_inputType}
        placeholder={placeholder}
        style={{ ...styles.input, ...inputStyle }}
        className={iconPosition === 'left' ? 'pl-10' : 'pr-10'}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
      />
    </div>
  );
};

const styles: IStyle = {
  wrapper: {
    position: 'relative',
    width: '100%',
  },
  input: {
    width: '100%',
  },
  icon: {
    padding: 4,
    position: 'absolute',
    boxSizing: 'border-box',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  verticalBar: {
    color: '#B4B4B4',
    marginRight: '3px',
  },
};

export default IconInput;
